import type { StylesConfig } from 'react-select';
type Option = {value: string, label: string};

export const SYSTEM_OPTIONS = [
    ['', 'CHOOSE SYSTEM ITEM'],
    ['Blue Sapphire', 'BLUE SAPPHIRE (NEELAM)'],
    ['Yellow Sapphire', 'YELLOW SAPPHIRE (PUKHRAJ)'],
    ['Red Coral', 'RED CORAL (MOONGA)'],
    ['Emerald', 'EMERALD (PANNA)'],
    ['Ruby', 'RUBY (MANIK)'],
    ['Pearl', 'PEARL (MOTI)'],
];

export const GOAL_OPTIONS = [
    ['', 'SELECT SPIRITUAL GOAL'],
    ['wealth', 'WEALTH & PROSPERITY'],
    ['career', 'BUSINESS & CAREER GROWTH'],
    ['health', 'HEALTH & EVIL EYE PROTECTION'],
    ['marriage', 'MARRIAGE & RELATIONSHIP SYNC'],
    ['education', 'EDUCATION & FOCUS MATRIX'],
];

export const SLIDES = [
    {
        tag: 'SACRED REMEDIES', from: 'from-[#F8EAD2]', via: 'via-[#F2D4A6]', to: 'to-[#E7A368]',
        title1: 'PROTECTION.', title2: 'PEACE. POWER.',
        desc: 'Original Rudraksha beads to balance your energy and calm your mind. Ideal for meditation, focus & spiritual progress.',
        label: '1–6 MUKHI RUDRAKSHA', price: 'Starting ₹200', cat_slug: 'rudraksha',
        img: 'https://res.cloudinary.com/doufbflam/image/upload/v1781697370/offers/vp40lmabfbpjvfbrak7w.webp',
    },
    {
        tag: 'LAB CERTIFIED GEMSTONES', from: 'from-[#FBF6EC]', via: 'via-[#F5EAD2]', to: 'to-[#E9D49E]',
        title1: '100% LAB CERTIFIED', title2: 'PUKHRAJ',
        desc: 'Premium quality Yellow Sapphire with Certificate Report & QC Check. Invest in authenticity and astrological strength.',
        label: 'YELLOW SAPPHIRE (PUKHRAJ)', price: 'From ₹8,500', cat_slug: 'gemstone',
        img: 'https://res.cloudinary.com/doufbflam/image/upload/v1781697387/offers/ziwoouiqjdnleghip91s.webp',
    },
];

export const CARAT_OPTIONS: Option[] = [
    { value: '', label: 'CARAT SYNC' },
    { value: '3-5', label: '3 - 5 CARATS' },
    { value: '5-8', label: '5 - 8 CARATS' },
    { value: '8+', label: '8+ CARATS' },
];

export const RANGE_OPTIONS: Option[] = [
    { value: '', label: 'INVESTMENT RANGE' },
    { value: '5000-15000', label: '₹5K - ₹15K' },
    { value: '15000-50000', label: '₹15K - ₹50K' },
    { value: '50000+', label: '₹50K+' },
];


// react-select styling matched to the dark finder card (h-12, rounded-xl,
// translucent control, white menu with dark options like the old natives).
export const FINDER_SELECT_STYLE: StylesConfig = {
  control: (base, state) => ({
    ...base,
    minHeight: '3rem',
    backgroundColor: 'rgba(255,255,255,0.05)',
    borderRadius: '0.75rem',
    borderColor: state.isFocused ? 'color-mix(in srgb, var(--color-secondary) 50%, transparent)' : 'rgba(255,255,255,0.15)',
    boxShadow: state.isFocused ? '0 0 0 2px color-mix(in srgb, var(--color-secondary) 30%, transparent)' : 'none',
    fontSize: '0.75rem',
    cursor: 'pointer',
    '&:hover': { borderColor: 'color-mix(in srgb, var(--color-secondary) 50%, transparent)' },
  }),
  valueContainer: (base) => ({ ...base, padding: '0 0.5rem 0 1rem', flexWrap: 'nowrap' }),
  singleValue: (base) => ({ ...base, color: 'white' }),
  input: (base) => ({ ...base, color: 'white' }),
  placeholder: (base) => ({
    ...base,
    color: 'rgba(255,255,255,0.4)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, color: 'rgba(255,255,255,0.3)', '&:hover': { color: 'rgba(255,255,255,0.6)' } }),
  clearIndicator: (base) => ({ ...base, color: 'rgba(255,255,255,0.3)', '&:hover': { color: 'rgba(255,255,255,0.6)' } }),
  menu: (base) => ({ ...base, borderRadius: '0.75rem', overflow: 'hidden' }),
  // The menu portals to <body> so the card's overflow-hidden can't clip it —
  // keep it above sticky headers and overlays.
  menuPortal: (base) => ({ ...base, zIndex: 60 }),
  option: (base, state) => ({
    ...base,
    fontSize: '0.75rem',
    cursor: 'pointer',
    color: state.isSelected ? 'white' : '#1f2937',
    backgroundColor: state.isSelected
      ? 'var(--color-secondary)'
      : state.isFocused
        ? 'color-mix(in srgb, var(--color-secondary) 10%, white)'
        : 'white',
  }),
}